import { render } from "./Indecision.vue?vue&type=template&id=68131437&scoped=true"
import script from "./Indecision.vue?vue&type=script&lang=js"
export * from "./Indecision.vue?vue&type=script&lang=js"

import "./Indecision.vue?vue&type=style&index=0&id=68131437&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LUIS\\Desktop\\Dev\\VueJS\\Vue Beginner\\indesicion-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68131437"]])

export default __exports__